import React, { useState, forwardRef, useImperativeHandle } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const PdfPreviewDialog = forwardRef(({ dialogHeader = "PDF Preview" }, ref) => {
  const [visible, setVisible] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    open: async (apiEndpoint) => {
      setLoading(true);
      try {
        const response = await fetch(apiEndpoint);

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        setPdfUrl(url);
        setVisible(true);
      } catch (error) {
        console.error("Error fetching PDF:", error);
      } finally {
        setLoading(false);
      }
    },
    close: () => {
      setVisible(false);
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
        setPdfUrl(null);
      }
    },
  }));

  const onHide = () => {
    setVisible(false);
    if (pdfUrl) {
      URL.revokeObjectURL(pdfUrl);
      setPdfUrl(null);
    }
  };

  const dialogFooter = (
    <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
      <Button label="Close" icon="pi pi-times" onClick={onHide} className="p-button-text" />
      {pdfUrl && (
        <a href={pdfUrl} download="asha_incentive.pdf" style={{ textDecoration: "none" }}>
          <Button label="Download" icon="pi pi-download" />
        </a>
      )}
    </div>
  );

  return (
    <Dialog
      header={dialogHeader}
      visible={visible}
      style={{ width: "70vw", height: "80vh" }}
      onHide={onHide}
      footer={dialogFooter}
      maximizable
    >
      {loading ? (
        <p>Loading preview...</p>
      ) : pdfUrl ? (
        <iframe
          src={pdfUrl}
          title="PDF Viewer"
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      ) : (
        <p>No PDF selected</p>
      )}
    </Dialog>
  );
});

export default PdfPreviewDialog;
